export default "__VITE_ASSET__COqG0IzM__"